{
    "intl-msg:common-message.error.generic.headline": "Oh snap! Something went wrong.",
    "intl-msg:common-message.error.generic.message": "We could not load your data. Please try again.",
    "intl-msg:common-message.error.generic.retryOrSupport": "Please try again. If the error appears repeatedly please contact the RIO customer support team.",
    "intl-msg:starterTemplate.moduleName": "Starter Template",
    "intl-msg:starterTemplate.reloadPage": "Reload",
    "intl-msg:starterTemplate.sublink.more": "More",
    "intl-msg:starterTemplate.sublink.intro": "Introduction"
}
